<template>
  <source :srcset="image.getTyrionSrc(t_type, type === 'webp' ? 'webp' : null)" :type="imageType"
          :sizes="`${imageSize}px`">
</template>

<script setup lang="ts">

import {computed, PropType} from "vue";
import Image from "../../../lib/models/Image";

const props = defineProps({
  image: Object as PropType<Image>,
  type: String,
  t_type: String,

})

const imageType = computed(() => {
  if (props.type === 'webp') {
    return 'image/webp';
  } else if (['jpeg', 'jpg'].indexOf(props.type) > -1) {
    return 'image/jpeg';
  } else if (props.type === 'png') {
    return 'image/png';
  } else if (props.type === 'svg') {
    return 'image/svg+xml';
  } else if (props.type === 'gif') {
    return 'image/gif';
  }
});

const imageSize = computed(() => {
  if (props.t_type === 'thumbw') {
    return 400;
  } else if (props.t_type === 'thumb_mw') {
    return 800;
  } else {
    return Number(props.image.width).toFixed(0)
  }
})
</script>
